exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".percentage[data-v-29e33434] {\n  font-size: 1.3rem;\n  color: #0374d7;\n}\n.percentage.inverse[data-v-29e33434] {\n  color: white;\n}\n", ""]);

// exports
